import Icon from '../components/Icon.vue'

Icon.register({
  underline: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M32 64c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h144c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32v160c0 44.2 35.8 80 80 80s80-35.8 80-80v-160h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h144c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32v160c0 88.2-71.8 160-160 160s-160-71.8-160-160v-160h-32zM432 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/underline.js
// module id = 2047
// module chunks = 0